import axios from "axios";
import { errorHandler } from "./errorHandler";

export const postWebsiteFile = async (formData: FormData): Promise<void> => {
  const token = localStorage.getItem("token");
  try {
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/websites/upload-website-csv`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (err: any) {
    errorHandler(err);

    const message =
      err.response?.data?.message || err.message || "Failed to upload CSV";

    throw new Error(message);
  }
};
